import { render } from "./FormSecretInput.vue?vue&type=template&id=66b4d3f3"
import script from "./FormSecretInput.vue?vue&type=script&lang=js"
export * from "./FormSecretInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__